/**************************************************
 * Nombre:       Registro
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {useFormulario} from "../Modulo_formularios/Hooks/useFormulario";
import Formulario_Registro from "./Formularios/Formulario_Registro";
import {ArrowBack, CheckOutlined} from '@mui/icons-material'
import {guardarDoc} from "../Servicios/BD/guardarDoc";
import {getID} from "../Servicios/BD/useEscucharUsuarioToCorreo";
import {PAISESINDICATIVO} from "../Modulo_formularios/Recursos/indicativos";
import {funCrearUsuario} from "../Servicios/Auth/funCrearUsuario";
import {obtenerDoc} from "../Servicios/BD/obtenerDoc";
import {actualizarDoc} from "../Servicios/BD/actualizarDoc";
import {useCargador} from "../Modulo_Cargador/Hooks/useCargador";
import logo from '../Recursos/logo_redondo.svg'

const Registro = ({setEsRegistro}) => {
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: {}})
    const {Cargador, Avisos, nuevoAviso, terminar, iniciarCarga} = useCargador({logoRedondo: logo})

    const registrarse = async () => {
        let entidad = await obtenerEntidad();
        iniciarCarga();

        entidad.fecha = new Date().getTime()
        entidad.estado = 'Aceptado'
        entidad.indicativo = obtenerIndicativo(entidad.pais)
        entidad.id = getID(entidad.correo)
        entidad.notificaciones = 'Si'


        let doxCueta = await obtenerDoc('cuentas', entidad.id)

        if (doxCueta.res && doxCueta.data) {

            await actualizarDoc('cuentas', entidad.id, entidad)

        } else {
            await guardarDoc('cuentas', entidad)
        }
        let dox = await funCrearUsuario(entidad.correo, entidad.pass)
        if (!dox.res) {
            terminar({aviso: dox.data, variante: 'error'})
        }
        terminar({aviso: 'Ingreso exitoso',})

    }

    const obtenerIndicativo = (pais) => {

        let index = PAISESINDICATIVO.findIndex((it) => it.nameES === pais)
        return parseInt(PAISESINDICATIVO[index].phoneCode)
    }

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Cargador/>

            <Avisos/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: 24, fontWeight: 800}}>Registro</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                <Typography sx={{fontSize: 16, fontWeight: 300, lineHeight: 1.1}}>Si aun no perteneces a esta la
                    comunidad de Team Tufiño
                    registrate llenando los siguientes datos</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 3}}>
                <Formulario_Registro props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 3, mb: 0}}>
                <Button fullWidth startIcon={<CheckOutlined/>}
                        onClick={() => registrarse()}
                        sx={{pt: 1.5, pb: 1.5, mx: 1}}
                >Registrarme</Button>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mb: 2, px: 1, mt: 2}}>
                <Button
                    onClick={() => setEsRegistro(false)}
                    variant={'text'} startIcon={<ArrowBack/>}>Ya he creado mi cuenta</Button>
            </Grid>

        </Grid>
    )

}
export default Registro